import styled, {css} from 'styled-components';
import {DEVICE} from '../../utils/device';
import {getBackgroundColor} from '../../utils/common';
import {CustomIcon} from '../CustomIcon';
import {ErrorMessage as BaseErrorMessage} from '../../utils/styled';

type WrapperProps = {
  disabled?: boolean;
};

type StyledInputProps = {
  disabled?: boolean;
  $invalid?: boolean;
  $isEmpty?: boolean;
  $isFocused?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 288px;
  min-height: 44px;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `};

  @media (max-width: ${DEVICE.mobileS}) {
    width: 293px;
  }
`;

export const WrapperInput = styled.div<{disabled?: boolean}>`
  min-height: 44px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${({disabled}) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `}
`;

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input<StyledInputProps>`
  width: 100%;
  outline: none;
  margin: 0;
  font-size: 16px;
  transition: background-color 0.25s ease-in-out;
  padding: 13px 16px 13px 9px;
  box-sizing: border-box;
  border-radius: 7px;
  border: none;
  text-overflow: ellipsis;
  height: 48px;
  font-family: inherit;
  font-weight: 400;
  line-height: 24px;
  color: var(--font-primary);
  background-color: ${({$isEmpty, $isFocused}) =>
    getBackgroundColor($isEmpty, $isFocused)};

  &::placeholder {
    font-weight: 400;
    color: #9696b9;
    opacity: 1;
    text-overflow: ellipsis;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: var(--font-primary);
    transition: background-color 5000s ease-in-out 0s;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
    -moz-appearance: textfield;
  }
`;

export const StatusIcon = styled.img<{error: boolean}>`
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 2;
  cursor: ${props => (props.error ? 'pointer' : 'default')};
  outline: none;
`;

export const ContentStatusIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 2;
  outline: none;
`;

export const StatusCustomIcon = styled(CustomIcon)`
  path,
  stop {
    stop-color: var(--primary);
  }
`;

export const InputErrorMessage = styled(BaseErrorMessage)``;
